import React, { useState, useEffect, useRef } from 'react';
import styles from 'components/quote_builder_widget/shared/_customer_popup.module.scss';
import { joinClassNames } from 'components/quote_builder_widget/shared/customerPopupClassNames';

// The first step after Submit when the owner asks for the customer's contact details (the widget settings' Customer
// tab): the asked fields, then the quote request is sent with them. With 2FA on, CustomerConfirmationPopup follows.
// classNames: the theme's customerPopupClassNames, which give the popup the look of the form behind it.
const CustomerContactPopup = ({ fields, initialValues, sending, errorMessage, onSend, onClose, classNames }) => {
  const [values, setValues] = useState(initialValues);
  const firstInputRef = useRef(null);

  useEffect(() => {
    firstInputRef.current?.focus();
  }, []);

  const send = (event) => {
    event.preventDefault();
    if (!sending) {
      onSend(values);
    }
  };

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} data-widget-element="customer-contact-popup" onKeyDown={onKeyDown}>
      <form
        className={joinClassNames(styles.card, classNames.card)}
        role="dialog"
        aria-modal="true"
        aria-labelledby="customer-contact-title"
        onSubmit={send}
        noValidate
        data-widget-element="customer-contact-card"
      >
        <h4 id="customer-contact-title" className={styles.title} data-widget-element="customer-contact-title">
          {t('quote_builder_widget.customer_contact_title')}
        </h4>
        {fields.map((field, index) => (
          <div className={styles.field} key={field.name}>
            <label className={classNames.label} htmlFor={`customer-contact-${field.name}`} data-widget-element="customer-contact-label">
              {t(field.label)}
            </label>
            <input
              ref={index === 0 ? firstInputRef : undefined}
              id={`customer-contact-${field.name}`}
              className={classNames.input}
              type={field.type}
              name={field.name}
              value={values[field.name] || ''}
              onChange={(event) => setValues((previous) => ({ ...previous, [field.name]: event.target.value }))}
              autoComplete={field.autoComplete}
              inputMode={field.inputMode}
              placeholder={t(field.placeholder)}
              aria-required="true"
              data-widget-element="customer-contact-input"
            />
          </div>
        ))}
        {errorMessage && (
          <div className={joinClassNames(styles.message, classNames.error)} role="alert" data-widget-element="customer-contact-error">{errorMessage}</div>
        )}
        <div className={styles.buttonRow}>
          <button
            type="submit"
            className={classNames.button}
            disabled={sending}
            aria-busy={sending}
            data-widget-element="customer-contact-send"
          >
            {t('quote_builder_widget.customer_contact_send')}
          </button>
        </div>
        <div className={styles.actions}>
          <span />
          <button type="button" className={joinClassNames(styles.linkButton, classNames.link)} onClick={onClose} data-widget-element="customer-contact-cancel">
            {t('quote_builder_widget.cancel')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CustomerContactPopup;
